import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Livrări externe',
  fields: {
    pickup: 'Ridicare',
    dropoff: 'Livrare',
    status: 'Status',
    estimated_time: 'Timp estimat',
    actual_time: 'Timp efectiv',
    actions: 'Acțiuni',
    time: 'Timp',
    pickup_estimate: 'Estimare ridicare',
    dropoff_estimate: 'Estimare livrare',
  },
  labels: {
    pickup: 'Ridicare',
    dropoff: 'Livrare',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Șofer în așteptare',
    [DeliveryStatus.RunnerAssigned]: 'Șofer atribuit',
    [DeliveryStatus.OnRoutePickup]: 'În drum spre ridicare',
    [DeliveryStatus.ArrivedPickup]: 'Ajuns la ridicare',
    [DeliveryStatus.PickedUp]: 'Ridicat',
    [DeliveryStatus.OnRouteDropoff]: 'În drum spre livrare',
    [DeliveryStatus.ArrivedDropoff]: 'Ajuns la livrare',
    [DeliveryStatus.Completed]: 'Finalizat',
    [DeliveryStatus.Cancelled]: 'Anulat',
  },
  buttons: {
    actions: 'Acțiuni',
    open_tracking_url: 'Urmăriți livrarea',
    show_order_details: 'Afișați detaliile comenzii',
    call_restaurant: 'Sunați restaurantul',
  },
  toasts: {
    failed_to_load_data: 'Datele nu au putut fi încărcate',
  },
};
